import React from 'react';
import '../../utils/Style/component/ProgressBar.scss'

const ProgressBar = ({ currentStep, steps }) => {
    return (
      <div className="progressbar">
        {steps.map((step, index) => (
          <div key={index} className={`step ${currentStep === index + 1 ? 'active' : ''}`}>
              <div className='step-number'>{index + 1}</div>
              <div className='step-title'>{step}</div>
          </div>
        ))}
      </div>
    );
  };
  
  export default ProgressBar;